// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader_loaderWrapper__SJeJh"};